export class Color {

    R: number;
    G: number;
    B: number;

        constructor(r, g, b) {
            this.R = r;
            this.G = g;
            this.B = b;
        }
}
